var lastWidth = lastHeight = 0;
var scrollTop, announcementHeight = 0;

$(document).ready(function()
{
  // Submenu
  $('button.sliderow.no-click').click(function(e){
    e.preventDefault();
    return false;
  });
  
  $('button.sliderow.open-submenu-v2').click(function(e){
    e.preventDefault();
    
    var id = $(this).data('sliderule-open-v2');
    var target = $('#' + id);
    
    $(this).toggleClass('open');
    target.toggleClass('open');
  });

  if ($('#Announcement--announcement').length > 0)
    $('body').addClass('announcement-exist');
  
  InitResize();
  InitScroll();
});


// RESIZE
function InitResize()
{
	$(window).resize(function(){ Resize(); });
	document.addEventListener("webkitfullscreenchange",function(){ Resize(); }, false);
	window.onorientationchange = function(){ var orientation = window.orientation; Resize(); }
	Resize();
	setTimeout(function(){ Resize(); }, 500);
}
function Resize()
{
	lastWidth = $(window).width();
	lastHeight = $(window).height();
  
    if ($('#Announcement--announcement').length > 0)
      announcementHeight = $('#Announcement--announcement').height();
}


// SCROLL
function InitScroll()
{
	$(window).scroll(function(){
		scrollTop = $(window).scrollTop();
    
        if ($('body').is('.template-index')) {
          if ($('.logo-homepage').is('.off') && scrollTop <= announcementHeight) $('.logo-homepage').removeClass('off');
          else if (!$('.logo-homepage').is('.off') && scrollTop > announcementHeight) $('.logo-homepage').addClass('off');

          if ($('.header__logo__link').is('.on') && scrollTop <= announcementHeight) $('.header__logo__link').removeClass('on');
          else if (!$('.header__logo__link').is('.on') && scrollTop > announcementHeight) $('.header__logo__link').addClass('on');

          if ($('body').is('.announcement-exist')) {
            if (scrollTop > announcementHeight) $('.theme__header').addClass('fixed');
            else $('.theme__header').removeClass('fixed');
          }
        }
	});
	$(window).scroll();
}